import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  DiagnosticReportMismatchedRecordCounterPartModel, DiagnosticReportMismatchedRecordDetailsModel,
  DiagnosticReportMismatchedRecordModel, DiagnosticReportMismatchedRecordSummaryModel
} from '@features/global-tax-calculator/models/diagnostic-report.model';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {take} from 'rxjs/operators';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {FlexSheetService} from "@features/spreadsheet/services/flex-sheet.service";
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'app-diagnostic-report-mismatched-record-details',
  templateUrl: './diagnostic-report-mismatched-record-details.component.html',
  styleUrl: './diagnostic-report-mismatched-record-details.component.scss'
})
export class DiagnosticReportMismatchedRecordDetailsComponent implements OnInit, OnDestroy{
  mismatchedRecordDetailsModel: DiagnosticReportMismatchedRecordDetailsModel;
  worksheetName = '';
  isLoading = false;
  entityCode = '';
  entityName = '';
  @Input() scenarioId: string;
  @Input() scenarioType: string;
  @Input() countryCode: string;
  @Input() set recordModelSummary(recordModelSummary: DiagnosticReportMismatchedRecordSummaryModel) {
    if (recordModelSummary) {
      this.fetchMismatchRecord(recordModelSummary);
    } else {
      this.isLoading = false;
      this.mismatchedRecordDetailsModel = null;
    }
  }

  @Input() set selectedWorksheetName(selectedWorksheetName: string) {
    this.worksheetName = selectedWorksheetName;
  }

  @Output() showReport$: EventEmitter<any> = new EventEmitter();
  @Output() navigateToSource$: EventEmitter<any> = new EventEmitter();
  qnrRecords: Array<DiagnosticReportMismatchedRecordCounterPartModel>= [];
  calculatorsRecords: Array<DiagnosticReportMismatchedRecordCounterPartModel>= [];
  constructor(private platformQueryService: PlatformQueryService,
              private flexSheetService: FlexSheetService,
              private snackBarService: SnackBarService) {

  }
  ngOnDestroy(): void {
  }

  ngOnInit(): void {

  }

  navigateToQnr(counterPart: DiagnosticReportMismatchedRecordCounterPartModel) {
    this.navigateToSource$.emit(counterPart);
  }
  navigateToScenarioCalculator(mismatchedRecordModel: DiagnosticReportMismatchedRecordModel) {
    const counterPart = new DiagnosticReportMismatchedRecordCounterPartModel();
    counterPart.countryCode = mismatchedRecordModel.countryCode;
    counterPart.countryName = mismatchedRecordModel.countryName;
    counterPart.type = 'Calculator';
    counterPart.fieldValues['WorksheetName'] = this.flexSheetService.getCurrentWorkSheet().name;
    counterPart.fieldValues['WorksheetId'] = this.flexSheetService.getCurrentWorksheetId();
    counterPart.fieldValues['RowIndex'] = mismatchedRecordModel.rowIndex;
    counterPart.fieldValues['ColumnIndex'] = mismatchedRecordModel.columnIndex;

    this.navigateToCalculator(counterPart);
  }

  navigateToCalculator(counterPart: DiagnosticReportMismatchedRecordCounterPartModel) {
    this.navigateToSource$.emit(counterPart);
  }

  onClickBack() {
    this.showReport$.emit({openDiagnosticReport: true, selectedReportId: this.mismatchedRecordDetailsModel?.mismatchedDetails?.id});
  }

  categorizeRecords() {
    if (!this.mismatchedRecordDetailsModel) {
      return;
    }
    this.qnrRecords = this.mismatchedRecordDetailsModel.mismatchedDetails.counterParts.filter(counterPart => counterPart.type === 'Qnr');
    this.calculatorsRecords = this.mismatchedRecordDetailsModel.mismatchedDetails.counterParts.filter(counterPart => counterPart.type === 'Calculator');
  }

  private fetchMismatchRecord(recordModelSummary: DiagnosticReportMismatchedRecordSummaryModel) {
    this.isLoading = true;
    const query = new PlatformQuery();
    query.name = 'GetDiagnosticReportMismatchRecordDetailsQuery';
    query.api = Api.Spreadsheet;
    query.fieldValues['ScenarioId'] = this.scenarioId;
    query.fieldValues['ScenarioType'] = this.scenarioType;
    query.fieldValues['RowIndex'] = recordModelSummary.rowIndex;
    query.fieldValues['ColumnIndex'] = recordModelSummary.columnIndex;
    query.fieldValues['FieldModelId'] = recordModelSummary.fieldModelId; // this will not be available if we click from cell
    query.fieldValues['DisplayText'] = recordModelSummary.displayText;
    query.fieldValues['HtmlComment'] = recordModelSummary.comment;
    query.fieldValues['CellValue'] = recordModelSummary.cellValue;
    query.fieldValues['WorksheetName'] = this.flexSheetService.getCurrentWorksheetName();

    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response  => {
      if (response && response.fieldValues) {
        this.mismatchedRecordDetailsModel = response.fieldValues['DiagnosticReportMismatchedRecordDetailsModel'];
        this.categorizeRecords();
        this.isLoading = false;
      } else {
        this.mismatchedRecordDetailsModel = null;
        this.isLoading = false;
      }
    }, err => {
      this.mismatchedRecordDetailsModel = null;
      this.isLoading = false;
    });
  }
}
